var TOTAL_COUNT_LIMIT = 10000;

var getTotalCount = function getTotalCount(totalCount) {
  return totalCount > TOTAL_COUNT_LIMIT ? TOTAL_COUNT_LIMIT : totalCount;
};

export { getTotalCount };